// extracted by mini-css-extract-plugin
export default {"container":"Section2_container__o6O44","contentContainer":"Section2_contentContainer__i7+f0","quote":"Section2_quote__++faN","btnContainer":"Section2_btnContainer__jwF-M"};